import VehicleFront from '@carvana/ds-icons/VehicleFrontSpot';
import Skeleton from '@carvana/ds-skeleton';
import useTradeVehicleImage from '~/hooks/common/useTradeVehicleImage';
import optimizeImage from '~/utilities/optimizeImage';

export default function TradeVehicleImage() {
  const { imageUrl, isLoaded, showImage } =
    useTradeVehicleImage('TradeVehicleImage');

  if (!isLoaded) {
    return (
      <Skeleton
        className="h-full w-full rounded-md"
        data-testid="trade-vehicle-image-loading"
        height={56}
        width={70}
      />
    );
  }

  if (showImage) {
    return (
      <img
        className="h-full w-full rounded-md object-cover"
        src={optimizeImage(imageUrl, {
          height: 200,
          format: 'auto',
          quality: 90
        })}
        alt="Trade-in vehicle"
        data-testid="trade-vehicle-image"
      />
    );
  }

  return (
    <div
      className="flex h-full w-full items-center justify-center bg-background-weak"
      data-testid="trade-vehicle-image-fallback"
    >
      <VehicleFront
        aria-hidden="true"
        className="h-40 w-40 shrink-0 text-brand-primary"
      />
    </div>
  );
}
